/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'clsx';
import { ComponentProps, forwardRef, memo } from 'react';

import { Button, Fade } from '@mui/material';

import { useSelectItemCatalogueButtonStyles } from './SelectItemCatalogueButton.styles';

type SelectItemCatalogueButtonProps = ComponentProps<typeof Button> & {
  isActive?: boolean;
  className?: string;
  component?: 'div' | undefined;
};

export const SelectItemCatalogueButton = memo(
  forwardRef<HTMLButtonElement, SelectItemCatalogueButtonProps>((props, ref) => {
    const { isActive, className, children, onClick, disabled, ...otherProps } = props;
    const classes = useSelectItemCatalogueButtonStyles();
    return (
      <Fade in>
        <Button
          {...otherProps}
          className={cx(classes.item, className, {
            [classes.itemActive]: isActive,
          })}
          ref={ref}
          disabled={disabled}
          onClick={disabled ? undefined : onClick}
        >
          {children}
        </Button>
      </Fade>
    );
  }),
);
